/* eslint-disable max-len */
/* eslint-disable complexity */

export default {
    name: 'yuri-submenu',
    methods: {
        /**
         * Cambiamos de pestaña del yuri-menu y comprobamos que no sea la misma en la que está
         * @param {Object} item Item al que cambiar la navegación
         */
        setActiveSubitem(item) {
            this.$store.dispatch('fullscreenStore/setFullScreen', false);
            if (this.$route.query.name !== item.route.query.name || this.$route.query.view !== item.route.query.view || this.$route.query.id !== item.route.query.id) {
                this.$router.replace(item.route);
            }
        },
        /**
         * Eliminamos una pestaña del 2º nivel.
         * Si estamos cerrando un formulario de incidencia, borramos los datos del estado
         * En el caso de que la pestaña activa del 1er nivel tenga más hijos, se redirije al último.
         * En el caso que se cierre la última pestaña hija de la pestaña activa del 1er nivel, se redirije al padre.
         * @param {Number} index Índice que queremos borrar el array
         */
        closeSubItem(index) {
            this.$store.dispatch('fullscreenStore/setFullScreen', false);
            this.$store.dispatch('formStore/deleteRouteForms', this.subitems[index].route.name);
            this.$store.dispatch('yuriMenuStore/removeSubItem', index)
                .then(() => this.$store.dispatch('yuriMenuStore/disableItemsSubMenu'))
                .then(() => {
                    const item = this.subitems[this.subitems.length - 1];
                    if (item) {
                        const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
                        this.$store.dispatch('yuriMenuStore/setActiveSubItem', { indexActiveMenu, item })
                            .then(() => {
                                if (this.$route.query.id !== item.route.query.id || this.$route.name !== item.route.query.name) {
                                    this.$router.push(item.route);
                                }
                            });
                    } else {
                        this.$router.push(this.activeItem.route);
                    }
                });
        },
        /**
         * @override
         */
        setActiveParentChild(item) {
            this.$store.dispatch('fullscreenStore/setFullScreen', false);
            this.$store.dispatch('yuriMenuStore/disableItemsSubMenu')
                .then(() => {
                    if (this.$route.name !== item.route.name || this.$route.params !== item.route.params || this.$route.query.id !== item.route.query.id) {
                        this.$router.push(item.route);
                    }
                });
        },
        /**
         * Set icon
         * @param {Object} el Element
         * @return {String} fa icon
         */
        icon(el) {
            // TO-DO: Limpiar esto!
            let icon = '';
            switch (el.route.name) {
                case 'groups_uuid':
                    icon = 'fa-users';
                    break;
                case 'users_uuid':
                    icon = 'fa-user';
                    break;
                case 'users_uuid_detail':
                case 'users_uuid_view':
                    icon = 'fa-user';
                    break;
                case 'permission_sets_uuid':
                case 'permission_sets_uuid_view':
                    icon = 'fa-key';
                    break;
                case 'issues_add':
                case 'issues_uuid':
                    icon = 'fa-exclamation-square';
                    break;
                case 'interveners_uuid':
                case 'interveners_uuid_view':
                    icon = 'fa-address-card';
                    break;
                case 'accounts_uuid':
                case 'accounts_uuid_view':
                case 'intervener_participant_accounts_uuid_view':
                    icon = 'fa-credit-card';
                    break;
                case 'related_operations_view':
                case 'operation_uuid_view':
                case 'operations_uuid':
                    icon = 'fa-database';
                    break;
                case 'issues_add_view':
                case 'issues_uuid_view':
                    icon = 'fa-exclamation-square';
                    break;
                case 'distributors_uuid':
                case 'distributors_add_view':
                case 'distributors_uuid_view':
                    icon = 'fa-handshake';
                    break;
                case 'conciliation2':
                case 'conciliation2-details':
                    icon = 'fa-balance-scale';
                    break;
                default: icon = 'fa-users';
            }
            return icon;
        }
    },
    computed: {
        /**
         * @override
         */
        subitems() {
            return this.$store.getters['yuriMenuStore/activeItemChildrens'];
        },
        /**
         * @override
         */
        activeItem() {
            const indexActive = this.$store.getters['yuriMenuStore/activeItem'];
            return this.$store.getters['yuriMenuStore/items'][indexActive];
        },
        /**
         * Comprobamos si hay alguna pestaña activa del segundo nivel
         * @return {Object} Comprueba que no tenga hijos activos
         */
        hasChildActive() {
            return this.subitems.find(x => {
                return x.active;
            });
        },
        /**
         * Obtenemos la posición de la pestaña activa del segundo nivel
         * @return {Number} Devuelve el indice del hijo activo
         */
        indexChildActive() {
            return this.subitems.indexOf(this.hasChildActive);
        }
    }
};
